import { render, staticRenderFns } from "./ddmCulture.vue?vue&type=template&id=0ea2dc44&scoped=true&"
import script from "./ddmCulture.vue?vue&type=script&lang=js&"
export * from "./ddmCulture.vue?vue&type=script&lang=js&"
import style0 from "./ddmCulture.vue?vue&type=style&index=0&id=0ea2dc44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2dc44",
  null
  
)

export default component.exports